
import { defineComponent, reactive, computed } from 'vue'
import { Icon } from 'scvant';
import plugin from '@/util/plugin.js';
import reportComfirmTitle from '../title.vue'

interface State {
    isShowMore: boolean;
    detectList: object[];
}

export default defineComponent({
    name: 'detect',
    setup(props) {
        let state: State = reactive({
            isShowMore: false,
            detectList: computed( () => {
                let list = [];
                // props.renderData.
                return list;
            })
        });
        function showOrHide (){
            state.isShowMore = !state.isShowMore;
            let type='';
            if (props.renderData.itemTitle === "环车检测") {
                // eslint-disable-next-line no-useless-escape
                type = '{\"openType\":huanchejian}';
            } else {
                // eslint-disable-next-line no-useless-escape
                type = '{\"openType\":ziyoujian}';
            }
        }
        return {
            state,
            showOrHide
        }
    },
    components: {
        [Icon.name]: Icon,
        reportComfirmTitle
    },
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        options: {
            type: String,
            default: () => {
                return ''
            }
        }
    },
    methods: {
        goPage(pageType) {
            let type='';
            if (pageType.indexOf('事故')>=0) {
                type='ziyoujian-shigu';
            }
            if (pageType.indexOf('火烧')>=0) {
                type='ziyoujian-huoshao';
            }
            if (pageType.indexOf('泡水')>=0) {
                type='ziyoujian-paoshui';
            }
            if (pageType.indexOf('动力')>=0) {
                type='ziyoujian-dongli';
            }
            if (pageType.indexOf('外观')>=0) {
                type='ziyoujian-waiguan';
            }
            if (pageType.indexOf('内饰')>=0) {
                type='ziyoujian-neishi';
            }
                
            let param = {
                methodName: 'goToModify',
                data: {
                    type: type
                }
            }
            console.log('type:', type);
            plugin.appFunHandler(param);
        }
    }
})
